// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header_top{overflow:inherit;height:40px}.lang-active{color:#ff4300!important;text-decoration:underline}@media only screen and (max-width:1024px){#exch-sep{display:none}}@media only screen and (max-width:625px){.header_top{height:auto}}", ""]);
// Exports
module.exports = exports;
